import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class DisasterMitigationFeature {
    constructor(doc)
    {
		this.label = null
		this.disasterMitigationFeatureType = null
		this.disasterMitigationFeatureTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.disasterMitigationFeatureType = x.getStringElement(doc, "./ns:DisasterMitigationFeatureType");
		this.disasterMitigationFeatureTypeOtherDescription = x.getStringElement(doc, "./ns:DisasterMitigationFeatureTypeOtherDescription");
   }

	 GetFeatureType() {
		return h.descriptionOrOther(this.disasterMitigationFeatureType, this.disasterMitigationFeatureTypeOtherDescription)
	 }
}

export class DisasterMitigation {
    constructor(doc) {
        this.disasterMitigationFeatures = [];
		
        const nodes = x.selectNodes(doc, "./ns:DISASTER_MITIGATION_FEATURE");
        if (nodes.length > 0) {
            nodes.forEach((xn) => {
                this.disasterMitigationFeatures.push(new DisasterMitigationFeature(xn));
            });
        }
    }

    GetFeatures() {
        if (!this.disasterMitigationFeatures || this.disasterMitigationFeatures.length === 0) return null;
        let features = "";
        for (const feature of this.disasterMitigationFeatures) {
            features = h.addWithSpacer(features, feature.GetFeatureType());
        }
        return features;
    }

    GetFeaturesList() {
        if (!this.disasterMitigationFeatures || this.disasterMitigationFeatures.length === 0) return null;
        const features = [];
        for (const feature of this.disasterMitigationFeatures) {
            features.push(feature.GetFeatureType());
        }
        return features;
    }

    HasFeatures() {
        if (!this.disasterMitigationFeatures || this.disasterMitigationFeatures.length === 0) return false;
        for (const feature of this.disasterMitigationFeatures) {
            if (feature.disasterMitigationFeatureType !== "None") return true;
        }
        return false;
    }

}

